import React, { useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import CanvasDraw from "react-canvas-draw";
import { ReportForm as ReportFormV1 } from './ReportFormV1'
import { ReportForm as ReportFormV2 } from './ReportFormV2'
import { ReportForm as ReportFormV3 } from './ReportFormV3'
import qs from 'query-string'

import { req, sides, resourceUrl, isAllowed, CAR_FORM_V1, CAR_FORM_V2, CAR_FORM_V3 } from '../../util'

import Btn from '../../components/Buttons/SaveButton'
import Input from '../../components/TextInput'

import { decompressFromUTF16 } from 'lz-string'

export const Report = ({ location }) => {

    const history = useHistory()
    const [car, setCar] = useState(null)
    const [imgs, setImgs] = useState({})
    const ctxRef = useRef([])
    const user = useSelector(state => state.user.user)

    useEffect(() => {
        let { id } = qs.parse(window.location.search)
        if (!location.state && !id) history.replace("/")
        let c = { id: id || location?.state?.id }
        req("GET", `car?id=${c.id}`).then(r => {
            let { success, data } = r
            if (!success) return
            setCar({ ...data })
        })
    }, [location.state, history])


    const submit = async () => {
        createImg()
        if (!car?.report?.kilometer) return alert("يرجى ادخال عداد المسافة !")
        let { success } = await req("POST", "car/report", { ...car.report, carID: car.id })
        if (success) {
            await print()
            history.replace("/carReport")
        }
    }

    const deleteReport = async () => {
        let { success } = await req("DELETE", "car/img?carID=" + car.id)
        if (success) {
            history.replace("/carReport")
        }
    }

    const print = () => {
        return new Promise((done) => {
            let content = document.getElementById("printAble");
            let pri = document.getElementById("ifmcontentstoprint").contentWindow;
            pri.document.open();
            pri.document.write(content.innerHTML);
            pri.document.close();
            setTimeout(() => {
                pri.focus();
                pri.print();
                done()
            }, 500)
        })
    }


    const createImg = () => {
        if (!car.bodyCheck) return
        Object.keys(sides).forEach(k => {
            let tempCanvas = document.createElement('canvas')
            tempCanvas.width = ctxRef.current[`${k}`].canvas.drawing.width
            tempCanvas.height = ctxRef.current[`${k}`].canvas.drawing.height
            let tempCtx = tempCanvas.getContext('2d')
            tempCtx.drawImage(ctxRef.current[`${k}`].canvas.grid, 0, 0)
            tempCtx.drawImage(ctxRef.current[`${k}`].canvas.drawing, 0, 0)
            setImgs(i => ({ ...i, [`${k}`]: tempCanvas.toDataURL("image/png") }))
        })
    }


    if (!car) {
        return <div>Loading...</div>
    }


    const getImgLink = (carObj = {}, side = '') => {
        if (!side || carObj[side] == null) return null
        return `${resourceUrl}/api/img/${carObj[`${side}`]}?auth=${localStorage.getItem("token")}`
    }

    return (
        <div className="container mx-auto p-4">
            {car.bodyCheck &&
                <>
                    <div className="text-center text-xl font-normal text-gray-800 my-2">كتابة تقرير العجلات</div>
                    <div className="text-center text-lg font-semibold text-gray-800">{car.brand} {car.model} {car.year}  # {car.id}</div>
                    {Object.keys(sides).map(k => {
                        return (
                            <div key={k} className="my-4 py-3">
                                <div className="flex justify-center">
                                    <CanvasDraw
                                        ref={ref => ctxRef.current[`${k}`] = ref}
                                        hideGrid={true}
                                        disabled
                                        lazyRadius={0}
                                        brushRadius={8}
                                        canvasWidth="720px"
                                        loadTimeOffset={0}
                                        backgroundColor="#cbd5e0"
                                        imgSrc={getImgLink(car, k)}
                                        saveData={car.imgs[k] ? decompressFromUTF16(car.imgs[k]) : ""}
                                        hideInterface
                                        immediateLoading
                                    />
                                </div>
                                <div>
                                    <div className="my-1 text-lg font-normal">{sides[k]}</div>
                                    <textarea
                                        placeholder={sides[k]}
                                        className="bg-gray-300 w-full p-2 text-lg font-semibold"
                                        rows={3}
                                        value={car.report[`${k}Note`]}
                                        onChange={evt => setCar({ ...car, report: { ...car.report, [`${k}Note`]: evt.target.value } })}
                                        disabled={user.phone !== car.branch}
                                    />
                                </div>
                            </div>
                        )
                    })}
                </>
            }
            {car.engineCheck &&
                <>
                    <div className="text-center text-xl font-normal text-gray-800 my-2">الفحص الميكانيكي</div>
                    <div className="flex flex-wrap justify-evenly">
                        <div className="flex flex-col px-1 mt-2 w-1/2">
                            <span className="font-semibold px-1 text-gray-800">المحرك</span>
                            <Input
                                value={car.report.engine}
                                onChange={evt => setCar({ ...car, report: { ...car.report, engine: evt.target.value } })}
                                disabled={user.phone !== car.branch}
                            />
                        </div>
                        <div className="flex flex-col px-1 mt-2 w-1/2">
                            <span className="font-semibold px-1 text-gray-800">الملاحظات</span>
                            <Input
                                value={car.report.gearBox}
                                onChange={evt => setCar({ ...car, report: { ...car.report, gearBox: evt.target.value } })}
                                disabled={user.phone !== car.branch}
                            />
                        </div>
                        <div className="flex flex-col px-1 mt-2 w-1/2">
                            <span className="font-semibold px-1 text-gray-800">معلومات الزبون السابقة</span>
                            <Input
                                value={car.report.airbag}
                                disabled={true}
                            />
                        </div>
                        <div className="flex flex-col px-1 mt-2 w-1/2">
                            <span className="font-semibold px-1 text-gray-800">عداد المسافة</span>
                            <Input
                                value={car.report.kilometer}
                                onChange={evt => setCar({ ...car, report: { ...car.report, kilometer: evt.target.value } })}
                                disabled={user.phone !== car.branch}
                            />
                        </div>
                        <div className="flex flex-col px-1 mt-2 w-1/2">
                            <span className="font-semibold px-1 text-gray-800">اسم الزبون</span>
                            <Input
                                value={car.client}
                                disabled={true}
                            />
                        </div>
                        <div className="flex flex-col px-1 mt-2 w-1/2">
                            <span className="font-semibold px-1 text-gray-800">رقم الهاتف</span>
                            <Input
                                value={car.phone}
                                disabled={true}
                            />
                        </div>
                    </div>

                </>
            }
            <div className="flex justify-center">
                {user.phone === car.branch &&
                    <>
                        <div className="w-1/5 justify-center">
                            <Btn onClick={submit} text="حفظ وطباعة" />
                        </div>
                        <div className="w-1/5 justify-center">
                            <Btn onClick={() => print()} text="طباعة" />
                        </div>
                        <div className="w-1/5 justify-center">
                            <Btn onClick={deleteReport} text="اعادة الى الفحص" />
                        </div>
                    </>
                }
            </div>

            {isAllowed(user, [CAR_FORM_V1]) && <ReportFormV1 car={car} imgs={imgs} branchID={user.phone} />}
            {isAllowed(user, [CAR_FORM_V2]) && <ReportFormV2 car={car} imgs={imgs} branchID={user.phone} />}
            {isAllowed(user, [CAR_FORM_V3]) && <ReportFormV3 car={car} imgs={imgs} branchID={user.phone} />}
            {!isAllowed(user, [CAR_FORM_V1, CAR_FORM_V2, CAR_FORM_V3]) && <ReportFormV1 car={car} imgs={imgs} branchID={user.phone} />}
        </div>
    )
}
